import {
	updatePaymentDetailsSuccess,
	resetAppState,
	updatePaymentDetailsStatus,
	getWalletDetailsSuccess
} from "../mutation-types";
import {
	ADD_UPDATE_PAYMENT_DETAILS,
	GET_PAYMENT_DETAILS,
	SHOW_ALERT,
	MAKE_TRANSACTION,
	SEND_SMS,
	RESET_PAYMENT_MODULE,
	ACCOUNT_VERIFICATION,
	GET_WALLET_DETAILS,
	FETCH_RETAILER_DATA
} from "../action-types";

import _get from "lodash/get";

import ApiService from "../api-service";
import { DEFAULT_ERROR_MESSAGE } from "../config";
import { BASE_URL } from "../../../config";

const state = {
	paymentDetails: {},
	walletDetails: {}
};

export const initialState = Object.assign({}, state);

const actions = {
	[ADD_UPDATE_PAYMENT_DETAILS.action]: (
		{ commit, rootState, dispatch },
		payload
	) => {
		const endpoint =
			BASE_URL + "/retailer-payment/v1.0.0/updatePaymentInfo";
		const requestPayload = {
			access_token: rootState.auth.ACCESS_TOKEN,
			params: {
				...payload
			}
		};
		return ApiService.post(endpoint, requestPayload)
			.then(data => {
				let errMsg = DEFAULT_ERROR_MESSAGE;
				if (
					data.statusCode === 200 &&
					typeof data.response &&
					data.response.status === "success"
				) {
					commit(updatePaymentDetailsSuccess, payload);
					dispatch(
						SHOW_ALERT.dispatch,
						{
							text: "Successfully updated!"
						},
						{ root: true }
					);
					return;
				} else if (data.errMsg) {
					errMsg = data.errMsg;
				}
				throw new Error(errMsg);
			})
			.catch(err => {
				console.error(err);
				const errMsg = err.message || DEFAULT_ERROR_MESSAGE;
				dispatch(SHOW_ALERT.dispatch, { text: errMsg }, { root: true });
			});
	},

	[ACCOUNT_VERIFICATION.action]: (
		{ commit, rootState, dispatch },
		payload
	) => {
		const endpoint = BASE_URL + "/retailer-payment/v1.0.0/verify";
		const requestPayload = {
			access_token: rootState.auth.ACCESS_TOKEN,
			params: {
				...payload
			}
		};
		return ApiService.post(endpoint, requestPayload)
			.then(data => {
				// console.log(data);
				let errMsg = DEFAULT_ERROR_MESSAGE;
				if (
					data.statusCode === 200 &&
					_get(data, "response.status", null) === "success"
				) {
					commit(updatePaymentDetailsStatus, data.response.status);
					return;
				} else if (
					_get(data, "response.status", null) === "failed" &&
					_get(data, "response.userNotify", false)
				) {
					dispatch(
						SHOW_ALERT.dispatch,
						{ text: data.response.reason },
						{ root: true }
					);
					return;
				} else if (_get(data, "response.status", null) === "failed") {
					errMsg = data.response.reason;
				} else if (data.errMsg) {
					errMsg = data.errMsg;
				}
				throw new Error(errMsg);
			})
			.catch(err => {
				console.error(err);
				const errMsg = err.message || DEFAULT_ERROR_MESSAGE;
				dispatch(SHOW_ALERT.dispatch, { text: errMsg }, { root: true });
				throw new Error(errMsg);
			});
	},

	[GET_PAYMENT_DETAILS.action]: ({ commit, rootState, dispatch }) => {
		const endpoint = BASE_URL + "/retailer-payment/v1.0.0/getPaymentInfo";
		const requestPayload = {
			access_token: rootState.auth.ACCESS_TOKEN,
			params: {
				userId: rootState.auth.USERID,
				username: rootState.auth.USERNAME,
				mode: "bank"
			}
		};
		return ApiService.post(endpoint, requestPayload)
			.then(data => {
				let errMsg = DEFAULT_ERROR_MESSAGE;
				if (
					data.statusCode === 200 &&
					typeof data.response === "object"
				) {
					commit(updatePaymentDetailsSuccess, data.response);
					return;
				} else if (data.errMsg) {
					commit(updatePaymentDetailsSuccess, {});
					return;
				}
				throw new Error(errMsg);
			})
			.catch(err => {
				console.error(err);
				const errMsg = err.message || DEFAULT_ERROR_MESSAGE;
				dispatch(SHOW_ALERT.dispatch, { text: errMsg }, { root: true });
				throw new Error(err);
			});
	},

	[MAKE_TRANSACTION.action]: ({ rootState, dispatch }, payload) => {
		const endpoint = BASE_URL + "/retailer-payment/v1.0.0/transact";
		const requestPayload = {
			access_token: rootState.auth.ACCESS_TOKEN,
			params: {
				...payload
			}
		};

		return ApiService.post(endpoint, requestPayload)
			.then(data => {
				let errMsg = DEFAULT_ERROR_MESSAGE;
				if (
					data.statusCode === 200 &&
					_get(data, "response.status", null) === "success"
				) {
					dispatch(
						FETCH_RETAILER_DATA.dispatch,
						{
							userId: payload.userId,
							dataKey: "retailerData"
						},
						{ root: true }
					);
					dispatch(
						SHOW_ALERT.dispatch,
						{
							text: "Payment Successfull!"
						},
						{ root: true }
					);
					return;
				} else if (data.errMsg) {
					errMsg = data.errMsg;
				}
				throw new Error(errMsg);
			})
			.catch(err => {
				const errMsg = err.message || DEFAULT_ERROR_MESSAGE;
				dispatch(SHOW_ALERT.dispatch, { text: errMsg }, { root: true });
				console.error(err);
			});
	},

	[SEND_SMS.action]: ({ commit, rootState, dispatch }, payload) => {
		const endpoint = BASE_URL + "/retailer-payment/v1.0.0/sendSms";
		const requestPayload = {
			access_token: rootState.auth.ACCESS_TOKEN,
			params: {
				...payload
			}
		};
		return ApiService.post(endpoint, requestPayload)
			.then(data => {
				// console.log(data);
				let errMsg = DEFAULT_ERROR_MESSAGE;
				if (
					data.statusCode === 200 &&
					typeof data.response === "object" &&
					data.response.status === "success"
				) {
					dispatch(
						SHOW_ALERT.dispatch,
						{ text: data.response.msg },
						{ root: true }
					);
					return;
				} else if (data.errMsg) {
					errMsg = data.errMsg;
				}
				throw new Error(errMsg);
			})
			.catch(err => {
				const errMsg = err.message || DEFAULT_ERROR_MESSAGE;
				dispatch(SHOW_ALERT.dispatch, { text: errMsg }, { root: true });
				console.error(err);
			});
	},

	[GET_WALLET_DETAILS.action]: ({ commit, rootState, dispatch }, payload) => {
		const endpoint = BASE_URL + "/retailer-payment/v1.0.0/sendSms";
		const requestPayload = {
			access_token: rootState.auth.ACCESS_TOKEN,
			params: {
				...payload
			}
		};
		return ApiService.post(endpoint, requestPayload)
			.then(data => {
				// console.log(data);
				let errMsg = DEFAULT_ERROR_MESSAGE;
				if (
					data.statusCode === 200 &&
					typeof data.response === "object"
				) {
					commit(getWalletDetailsSuccess, data.response);
					return;
				} else if (data.errMsg) {
					errMsg = data.errMsg;
				}
				throw new Error(errMsg);
			})
			.catch(err => {
				console.error(err);
				const errMsg = err.message || DEFAULT_ERROR_MESSAGE;
				dispatch(SHOW_ALERT.dispatch, { text: errMsg }, { root: true });
			});
	},

	[RESET_PAYMENT_MODULE.action]: ({ commit }) => {
		commit(resetAppState);
	}
};

const mutations = {
	[updatePaymentDetailsSuccess](state, payload) {
		state.paymentDetails = {
			...payload
		};
	},
	[updatePaymentDetailsStatus](state, status) {
		state.paymentDetails = {
			...state.paymentDetails,
			status
		};
	},
	[getWalletDetailsSuccess](state, payload) {
		state.walletDetails = {
			...payload
		};
	},
	[resetAppState](state) {
		Object.keys(initialState).forEach(key => {
			state[key] = initialState[key];
		});
	}
};

export default {
	namespaced: true,
	state,
	actions,
	mutations
};
